<template>
  <VDialogV3
    id="demand-v2-request-dialog"
    width="400px"
    class="demand-create-request-dialog"
    :entity="localRequest"
    :title="title"
  >
    <DemandRequestCreateForm
      :request="localRequest"
    />

    <template #footer>
      <VButton
        theme="primary"
        @click="save"
      >
        Сохранить
      </VButton>
      <VButton @click="closeDialog">
        Закрыть
      </VButton>
    </template>
  </VDialogV3>
</template>

<script lang="ts">

import DemandRequest           from '@/domains/DemandsV2/DemandRequest';
import DemandsV2Service        from '@/domains/DemandsV2/DemandsV2Service';

import DemandRequestCreateForm from '@/domains/DemandsV2/components/DemandV2Card/DemandV2RequestDialog/DemandRequestCreateForm.vue';

export default defineComponent({
  name: 'DemandV2RequestDialog',

  components: { DemandRequestCreateForm },

  props: {
    request: {
      type:    DemandRequest,
      default: null,
    },
  },

  emits: [
    DemandRequest.Events.Created,
    DemandRequest.Events.Updated,
  ],

  data() {
    return {
      /** cloneDeep потому что я не хочу чтобы потребность смутировала */
      localRequest: this.$core.utils.cloneDeep(this.request) as DemandRequest,
    };
  },

  computed: {
    editMode(): boolean {
      return Boolean(this.localRequest.isExisting);
    },

    title(): string {
      if (this.editMode) {
        return 'Редактирование заявки';
      }
      else {
        return 'Создание заявки';
      }
    },
  },

  methods: {
    closeDialog(): void {
      this.$core.dialogs.DemandV2RequestDialog.hide();
    },

    async save(): Promise<void> {
      let isSuccess: boolean;

      if (this.editMode) {
        isSuccess = await DemandsV2Service.updateRequest(this.localRequest);

        if (isSuccess) {
          this.$emit(DemandRequest.Events.Updated);
        }
      }
      else {
        isSuccess = await DemandsV2Service.addRequest(this.localRequest);

        if (isSuccess) {
          this.$emit(DemandRequest.Events.Created);
        }
      }

      if (isSuccess) {
        this.closeDialog();
      }
    },
  },
});
</script>